module.exports = "/fonts/fa-brands-400.eot?748ab466bee11e0b2132916def799916";